import React, {forwardRef} from 'react';
import cn from 'classnames';
import styles from './FieldRange.css';

type NativeInputProps = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export const FieldRange = forwardRef<HTMLInputElement, NativeInputProps>((props, ref) => {
	const {className, ...nativeProps} = props;

	return (
		<div className={cn(styles.root, className)}>
			<p className={cn(styles.edge, styles.isMin)}>{props.min}</p>
			<p className={cn(styles.edge, styles.isMax)}>{props.max}</p>
			<input ref={ref} className={styles.field} type='range' {...nativeProps} />
		</div>
	);
});

FieldRange.displayName = 'FieldRange';
